import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import {
  GcButtonComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { GcHeaderComponent } from '../shared/gc-header/gc-header.component';
import { UserService } from '../user/user.service';
import { changelog } from './changelog';
import { ChangelogEntryCardComponent } from './changelog-entry-card/changelog-entry-card.component';
import { filterChangelogEntries } from './changelog.helper';
import { ChangelogEntry } from './changelog.entities';

@Component({
  selector: 'app-changelog',
  imports: [
    ChangelogEntryCardComponent,
    GcButtonComponent,
    IpoTranslatePipe,
    GcHeaderComponent,
  ],
  templateUrl: './changelog.component.html',
  styleUrl: './changelog.component.scss',
})
export class ChangelogComponent {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  private readonly portalUser = toSignal(this.userService.getPortalUser$());
  private readonly isFederatedUser = computed<boolean>(
    () => this.portalUser()?.federatedUser === true,
  );

  visibleEntries = computed<ChangelogEntry[]>(() =>
    filterChangelogEntries(changelog, this.isFederatedUser()),
  );

  goToHome() {
    this.router.navigate(['/']);
  }
}
